module.exports = __webpack_public_path__ + "static/media/whatsapp1.b30492e9.png";